"use strict";
exports.__esModule = true;
exports.DefaultLookupProps = void 0;
var onSearch = function (codeQuery) { };
var onSearchSelection = function (codeQuery) { };
var FieldDefinitions = [
    { label: 'Procedure', value: 'cpt', key: 'CPT' },
    { label: 'Diagnosis', value: 'icd', key: 'ICD' },
    { label: 'Modifier', value: 'modifier', key: 'MODIFIER' }
];
var shouldShowResults = function (lookupState) {
    var _a;
    var active = lookupState.active, searching = lookupState.searching, codeQuery = lookupState.codeQuery;
    if (!active) {
        return false;
    }
    if (searching) {
        return true;
    }
    var text = (_a = codeQuery === null || codeQuery === void 0 ? void 0 : codeQuery.text) !== null && _a !== void 0 ? _a : '';
    if (codeQuery.searchType === "MODIFIER") {
        return text.length > 1;
    }
    return text.length > 2;
};
exports.DefaultLookupProps = {
    onSearch: onSearch,
    onSearchSelection: onSearchSelection,
    FieldDefinitions: FieldDefinitions,
    searchResults: [],
    shouldShowResults: shouldShowResults
};
//# sourceMappingURL=defaultLookupProps.js.map